import PageLayout from "@/components/layout/PageLayout";
import Platforms from "@/components/sections/Platforms";

export default function PlatformsPage() {
  return (
    <PageLayout testId="platforms-page">
      <Platforms />
    </PageLayout>
  );
}
